import { ErroredModel } from './ErroredModel';

export type Preference = ErroredModel & {
  uuid: string;
  key: string;
  value: string;
  description: string;
  color: string | null;
};

export type PreferenceDisplay = {
  value: string;
  color?: string | null;
};

export enum PREFERENCES_VALID_KEYS {
  ACCOUNT_STATUS = 'account_status',
  EVENT_TYPE = 'event_type',
  EVENT_LOCATION = 'event_location',
  ACCOUNT_SCHOOL_DISTRICT = 'account_school_district',
  EMPLOYEE_ROLE = 'employee_role',
  ACCOUNT_TYPE = 'account_type',
  TASK_TYPE = 'task_type',
  CONTACT_ROLE = 'contact_role',
  CONTACT_TITLE = 'contact_title',
  CONTACT_SALUTATION = 'contact_salutation',
  EMPLOYEE_TITLE = 'employee_title',
  TAG = 'tag',
  ADDRESS_TYPE = 'address_type',
}

export type PreferenceDeleteCheck = {
  label: string;
  path: string;
};
export const DEFAULT_PREFERENCE_COLOR = '#eeeeee';
